import api from '@/lib/axios';
import { API_ENDPOINTS } from '@/constants/api-endpoints';

export interface PricingRule {
  id: string;
  vehicle_type: string;
  base_fare: string;
  base_distance_km: string;
  per_km_rate: string;
  per_minute_rate: string;
  minimum_fare: string;
  surge_multiplier: string;
  commission_percent: string;
  helper_charge_per_person: string;
  helper_available: boolean;
  night_surcharge_percent: string;
  multi_stop_fee: string;
  capacity_min: number;
  capacity_max: number;
  best_for: string | null;
  city: string;
  state: string | null;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface CreatePricingRuleDto {
  vehicle_type: string;
  base_fare: number;
  base_distance_km: number;
  per_km_rate: number;
  per_minute_rate?: number;
  minimum_fare?: number;
  commission_percent: number;
  night_surcharge_percent?: number;
  multi_stop_fee?: number;
  helper_charge_per_person?: number;
  capacity_min?: number;
  capacity_max?: number;
  best_for?: string;
  city: string;
  state?: string | null;
  is_active?: boolean;
}

export const pricingApi = {
  getAll: async (): Promise<PricingRule[]> => {
    const res = await api.get<{ data: PricingRule[] } | PricingRule[]>(API_ENDPOINTS.PRICING.LIST);
    const raw = (res.data as any)?.data ?? res.data;
    return Array.isArray(raw) ? raw : [];
  },

  create: async (data: CreatePricingRuleDto): Promise<PricingRule> => {
    const res = await api.post<{ data: PricingRule }>(API_ENDPOINTS.PRICING.CREATE, data);
    return (res.data as any)?.data ?? res.data;
  },

  update: async (id: string, data: Partial<CreatePricingRuleDto>): Promise<PricingRule> => {
    const res = await api.put<{ data: PricingRule }>(API_ENDPOINTS.PRICING.DETAIL(id), data);
    return (res.data as any)?.data ?? res.data;
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(API_ENDPOINTS.PRICING.DETAIL(id));
  },

  seed: async (): Promise<void> => {
    await api.post(API_ENDPOINTS.PRICING.SEED);
  },
};
